:host {
  display: block;
  /** @prop --typeahead-max-width: Set the max width of the <anchor-typeahead> */
  --typeahead-max-width: 328px;
  /** @prop --typeahead-width: Set the width of the <anchor-typeahead> */
  --typeahead-width: 100%;
  /** @prop --typeahead-font-weight-label: Set the font weight of the <anchor-typeahead> label */
  --typeahead-font-weight-label: normal;
  /** @prop --typeahead-outline: Set the outline of the <anchor-typeahead> */
  --typeahead-outline: auto;
  /** @prop --typeahead-z-index: Set the z index of the <anchor-typeahead> */
  --typeahead-z-index: 1000;
  /** @prop --typeahead-border-width: Set the border width of the <anchor-typeahead> */
  --typeahead-border-width: var(--s-size-border-width-default);
  /** @prop --typeahead-border-radius: Set the border radius of the <anchor-typeahead> */
  --typeahead-border-radius: var(--s-size-radius-medium);
  /** @prop --typeahead-border-color: Set the border color of the <anchor-typeahead> */
  --typeahead-border-color: var(--s-color-border-default);
  /** @prop --typeahead-border-color-hover: Set the hover border color of the <anchor-typeahead> */
  --typeahead-border-color-hover: var(--s-color-outline-default);
  /** @prop --typeahead-border-color-focus: Set the focus border color of the <anchor-typeahead> */
  --typeahead-border-color-focus: var(--s-color-outline-default);
  /** @prop --typeahead-border-color-warning: Set the warning border color of the <anchor-typeahead> */
  --typeahead-border-color-warning: var(--s-color-border-error);
  /** @prop --typeahead-border-color-error: Set the error border color of the <anchor-typeahead> */
  --typeahead-border-color-error: var(--s-color-border-error);
  /** @prop --typeahead-border-color-readonly: Set the readonly border color of the <anchor-typeahead> */
  --typeahead-border-color-readonly: var(--s-color-border-divider);
  /** @prop --typeahead-border-color-disabled: Set the disabled border color of the <anchor-typeahead> */
  --typeahead-border-color-disabled: var(--s-color-border-divider);
  /** @prop --typeahead-icon-color: Set the icon color of the <anchor-typeahead> icon */
  --typeahead-icon-color: var(--s-color-icon-variant);
  /** @prop --typeahead-icon-color-disabled: Set the icon color of the <anchor-typeahead> icon when disabled */
  --typeahead-icon-color-disabled: var(--color-disabled);

  /**
   * @deprecated - This variable is deprecated in favour of the referenced variable and will be removed on Dec 10 2023
   */
  --typeahead-label-font-weight: var(--typeahead-font-weight-label);

  max-width: var(--typeahead-max-width);

  &,
  & * {
    box-sizing: border-box;
  }
}

.container {
  --input-field-width: calc(100% - (var(--typeahead-border-width) * 2));
  --input-field-border-width: var(--typeahead-border-width);
  --input-field-border-bottom-width: var(--typeahead-border-width);
  // --input-field-border-radius: var(--typeahead-border-radius);
  --input-field-border-top-right-radius: var(--typeahead-border-radius);
  --input-field-border-bottom-right-radius: var(--typeahead-border-radius);
  --input-field-border-bottom-left-radius: var(--typeahead-border-radius);
  --input-field-border-top-left-radius: var(--typeahead-border-radius);
  --input-field-border-color: var(--typeahead-border-color);
  --input-field-border-color-hover: var(--typeahead-border-color-hover);
  --input-field-border-color-focus: var(--typeahead-border-color-focus);
  --input-field-border-color-warning: var(--typeahead-border-color-warning);
  --input-field-border-color-error: var(--typeahead-border-color-error);
  --input-field-border-color-readonly: var(--typeahead-border-color-readonly);
  --input-field-border-color-disabled: var(--typeahead-border-color-disabled);

  position: relative;
  display: flex;
  flex-direction: column;
  &:focus-within {
    --input-field-outline: var(--typeahead-outline);
  }
  label {
    font-weight: var(--typeahead-label-font-weight);
  }

  .menu {
    display: none;
    list-style: none;
    position: absolute;
    z-index: var(--typeahead-z-index);
    top: 100%;
    left: var(--input-field-border-width);
    margin: 0;
    padding: 0;
    max-height: calc(min(300px, 33vh) - 2px);
    min-height: 44px;
    overflow: auto;
    overflow-x: hidden;
    width: calc(100% - (var(--input-field-border-width) * 2));
    border: var(--typeahead-border-width) solid var(--typeahead-border-color-focus);
    border-top-width: 0;
    border-bottom-right-radius: var(--typeahead-border-radius);
    border-bottom-left-radius: var(--typeahead-border-radius);

    .option {
      min-height: 44px;
      cursor: pointer;
    }
  }

  anchor-icon {
    color: var(--s-color-icon-variant);
  }

  &--disabled {
    anchor-icon {
      color: var(--color-disabled);
    }
  }
}

.container--expanded {
  --input-field-border-bottom-width: var(--s-size-border-width-active);
  --input-field-border-bottom-right-radius: 0px;
  --input-field-border-bottom-left-radius: 0px;
  margin-bottom: var(--p-size-static-0125);
  .menu {
    display: block;
  }
}

.container--results:focus-within {
  anchor-icon {
    transform: rotate(180deg);
  }
}

.menu.has-error,
.menu.menu--no-results {
  margin-left: 20px;
  width: calc(100% - (var(--input-field-border-width) * 2) - 20px);
}

.sr-only {
  position: absolute;
  width: var(--p-size-static-0125);
  height: var(--p-size-static-0125);
  padding: 0;
  margin: -var(--p-size-static-0125);
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
}
